import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CurrentUserModel } from "../models/account-ledger.model";
import { AuthService } from "../services/auth.service";

@Injectable()
export class CanActivateCateloguesV2 implements CanActivate {

    devops: Array<string> = [
        'iwelch@dickerdata.com.au',
        'james.barnes@dickerdata.com.au',
        'murali.ramachandran@dickerdata.com.au',
        'prabha.ganesan@dickerdata.com.au',
        'jing.dong@dickerdata.com.au',
        'kenny.liu@dickerdata.com.au',
        'riannan.dimou@dickerdata.com.au',
        'maria.chapman@dickerdata.com.au',
        'luis.davis@dickerdata.com.au',
        'shiva.kannekanti@dickerdata.com.au',
        'lam.nguyen@dickerdata.com.au',
        'ian.whitehead@dickerdata.com.au'
      ]

    constructor(private authService: AuthService, private router: Router) { }
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | Observable<boolean> {
        return this.authService.getLoginInfo().pipe(
            map((user: CurrentUserModel) => {
              
                // if (user && this.devops.includes(user.email)) {
                if (user && user.isStaffAccount) {
                    return true;
                } else {
                    // this.router.navigateByUrl('/home');
                    this.router.navigateByUrl('/catalogues');
                    return true;
                }
            })
        );
    }
}